export default class kvModal {
    constructor(param,slider) {

        this.$container;
        this.$target;
        this.$trigger;
        this.$close;

        this.$outContanier;

        this.param = param;
        this.slider = slider;

        this.status = {
            current : 0,
            mode : "close",
            setWidth: 0,
            openWidth: 0,
            motion: false
        }

        this.imagesIE = [
            'url(/assets/images/kv/b-kv_photo_modern_round.png)',
            'url(/assets/images/kv/b-kv_photo_natural_round.png)',
            'url(/assets/images/kv/b-kv_photo_stylish_round.png)',
            'url(/assets/images/kv/b-kv_photo_relax_round.png)'
        ]
        this.imagesComp = [
            'url(/assets/images/kv/b-kv_photo_modern_L.jpg)',
            'url(/assets/images/kv/b-kv_photo_natural_L.jpg)',
            'url(/assets/images/kv/b-kv_photo_stylish_L.jpg)',
            'url(/assets/images/kv/b-kv_photo_relax_L.jpg)'
        ]

    }
    init(scroll,mouse,splash){

        this.$container = document.getElementById("p-kv-modal")
        this.$target = document.querySelectorAll(".kv-modal-item")

        this.$imageWrap = document.getElementById("p-kv-slider")
        this.$trigger = document.querySelectorAll(".slide-image-ref")
        this.$close = document.querySelectorAll(".kv-modal-close")

        this.$kvHideObj = document.querySelectorAll(".kv-copy-inner .js__opacity")
        this.$kvHideObjX = document.querySelectorAll(".kv-copy-inner .js__opacity-x")
        this.$kvHideObjY = document.querySelectorAll(".kv-copy-inner .js__opacity-y")

        this.$outContainer = document.querySelectorAll(".js__kv-modal-out")

        for (let i in this.$trigger) {
            if (this.$trigger[i].nodeType != 1) break

            this.$trigger[i].addEventListener("click",()=>{

                this.status.current = i;

                if(this.status.motion||!splash.status.done) return;
                this.status.motion = true;

                // if(this.slider.status.slide.motion) return;
                this.slider.status.slide.slideTime = 0;
                // this.slider.status.slide.motion = true;

                if(this.status.mode == "close"){
                    this._show(scroll,mouse)
                }else{
                    this._out(scroll,mouse)
                }

            })
            this.$close[i].addEventListener("click",()=>{


                this._out(scroll,mouse)


            })

        }






    }
    render(mouse,scrollInc){

    }
    resize(w,h,deviceSize){


    }
    _show(scroll,mouse){
        this.status.mode = "open"

        this.$container.classList.add('is-open');
        if(mouse) mouse.iconMot()

        //scroll禁止
        scroll.to(0)
        scroll.exResize(window.innerHeight,false)

        //写真全体見せ
        this.status.openWidth = this.$imageWrap.clientWidth * 1
        if(this.param.displayType == 'sp'){
            let _y = ((this.$imageWrap.clientHeight - this.$trigger[0].clientHeight) / 2) - (750/window.innerWidth*16)
            TweenMax.to(this.$trigger[this.status.current], .9, {
                y: -_y,
                ease: Power2.easeOut,
                onStart: () => {
                    TweenMax.to(this.$trigger[this.status.current], 2.0, {
                        delay: 0.5,
                        webkitClipPath:'circle('+this.status.openWidth+' at 50% 50%)',
                        clipPath:'circle('+this.status.openWidth+' at 50% 50%)',
                        ease: Power2.easeOut
                    })
                }
            })
        }else if(this.param.browserType == 'ie'){
            TweenMax.to(this.$trigger[this.status.current], 1.2, {
                opacity: 0,
                ease: Power2.easeOut,
                onComplete: () => {
                    TweenMax.set(this.$trigger[this.status.current], {
                        width: '100%',
                        height: '100%'
                    });
                    TweenMax.set(this.$trigger[this.status.current].querySelector('.image'), {
                        css: {
                            backgroundImage: this.imagesComp[this.status.current],
                        },
                        onComplete: () => {
                            TweenMax.to(this.$trigger[this.status.current], 1.2, {
                                delay: 0.6,
                                opacity: 1,
                                ease: Power2.easeOut
                            })
                        }
                    });
                    this.$trigger[this.status.current].querySelector('.image').style.backgroundSize = 'cover';
                }
            })
        }else{
            TweenMax.to(this.$trigger[this.status.current], 2.2, {
                delay: .4,
                webkitClipPath:'circle('+this.status.openWidth+' at 50% 50%)',
                clipPath:'circle('+this.status.openWidth+' at 50% 50%)',
                ease: Power2.easeOut
            })
        }
        this.$container.classList.add("is-active")

        this.$target[this.status.current].classList.add("is-current")

        //modal表示
        TweenMax.set([this.$container,this.$target[this.status.current]],{
            opacity : 1,
        })

        //kv非表示
        TweenMax.staggerTo(this.$kvHideObj, 0.8,{
            opacity : 0,
            ease: Power2.easeOut
        })
        TweenMax.to(this.$kvHideObjX, 0.8,{
            opacity : 0,
            x: 20,
            ease: Power2.easeOut
        })
        TweenMax.to(this.$kvHideObjY, 0.8,{
            opacity : 0,
            y: 20,
            ease: Power2.easeOut
        })

        //kv表示
        TweenMax.staggerFromTo(this.$target[this.status.current].querySelectorAll('.js__modal-show'), 1.4,{
            opacity: 0,
            y: 10,
        },{
            delay: 1,
            opacity: 1,
            y: 0,
            ease: Power2.easeOut
        },0.08)

        TweenMax.fromTo(this.$target[this.status.current].querySelectorAll('.js__modal-show-x'), 1.4,{
            opacity: 0,
            x: -20,
        }, {
            delay: 1.2,
            opacity: 1,
            x: 0,
            ease: Power2.easeOut,
            onComplete: () => {
                this.status.motion = false;
                this.slider.status.slide.slideTime = 0;
                this.slider.status.slide.motion = false;
            }
        })
        TweenMax.fromTo(this.$target[this.status.current].querySelectorAll('.js__modal-show-y'), 1.4,{
            opacity: 0,
            y: 20,
        }, {
            delay: 1.2,
            opacity: 1,
            y: 0,
            ease: Power2.easeOut
        })

        for(let i in this.$outContainer){
            if(this.$outContainer[i].nodeType==1){
                this.$outContainer[i].classList.add("is-disable")
            }
        }

        TweenMax.to(this.$outContainer,1.4,{
            ease: Power2.easeOut,
            css:{
                'pointer-events': 'none',
                 'opacity' : 0,
            }
        })


    }
    _out(scroll,mouse){
        this.status.mode = "close"

        this.$container.classList.remove('is-open');
        if(mouse) mouse.iconMot()

        this.$container.classList.remove("is-active")
        this.$target[this.status.current].classList.remove("is-current")

        //写真全体見せない
        if(this.param.displayType == 'sp'){
            this.status.setWidth = this.$imageWrap.clientWidth * 0.373
        }else if(this.param.browserType == 'ie'){
            TweenMax.to(this.$trigger[this.status.current], 1.2, {
                opacity: 0,
                ease: Power2.easeOut,
                onComplete: () => {
                    TweenMax.set(this.$trigger[this.status.current], {
                        width: '85%',
                        height: '85%'
                    });
                    TweenMax.set(this.$trigger[this.status.current].querySelector('.image'), {
                        css: {
                            backgroundImage: this.imagesIE[this.status.current],
                        },
                        onComplete: () => {
                            TweenMax.to(this.$trigger[this.status.current], 1.2, {
                                delay: 0.6,
                                opacity: 1,
                                ease: Power2.easeOut,
                                onComplete: () => {
                                    this.slider.status.slide.motion = false;
                                }
                            })
                        }
                    });
                    this.$trigger[this.status.current].querySelector('.image').style.backgroundSize = '37.5vw';
                }
            })
        }else{
            this.status.setWidth = this.$imageWrap.clientWidth * 0.337
        }
        if(this.param.browserType != 'ie') {
            TweenMax.to(this.$trigger[this.status.current], 1.2, {
                delay: 0.6,
                webkitClipPath: 'circle(' + this.status.setWidth + ' at 50% 50%)',
                clipPath: 'circle(' + this.status.setWidth + ' at 50% 50%)',
                y: 0,
                ease: Power2.easeOut,
                onComplete: () => {
                    this.slider.status.slide.motion = false;
                }
            })
        }

        TweenMax.to(this.$container,0.4,{
            opacity : 0,
        })

        //kv表示
        TweenMax.staggerFromTo(this.$kvHideObj, 0.8,{
            opacity: 0,
            y: 10,
        },{
            delay: 1,
            opacity: 1,
            y: 0,
            ease: Power2.easeOut
        },0.06)

        TweenMax.fromTo(this.$kvHideObjX, 1.4,{
            opacity: 0,
            x: -20,
        }, {
            delay: 1.2,
            opacity: 1,
            x: 0,
            ease: Power2.easeOut,
            onComplete: () => {
                this.status.motion = false;
            }
        })
        TweenMax.fromTo(this.$kvHideObjY, 1.4,{
            opacity: 0,
            y: -20,
        }, {
            delay: 1.2,
            opacity: 1,
            y: 0,
            ease: Power2.easeOut,
        })

        //modal非表示
        TweenMax.staggerTo(this.$target[this.status.current].querySelectorAll('.js__modal-show'), 1.4,{
            opacity: 0,
            ease: Power2.easeOut
        },0)
        TweenMax.to(this.$target[this.status.current].querySelector('.js__modal-show-x'), 1.4,{
            opacity: 0,
            x: 20,
            ease: Power2.easeOut,
            onComplete:()=>{
                //scroll許可
                scroll.exResize(scroll.bodyHeight,true)
                this.status.motion = false;
            }
        })
        TweenMax.to(this.$target[this.status.current].querySelector('.js__modal-show-y'), 1.4,{
            opacity: 0,
            y: 20,
            ease: Power2.easeOut
        })

        for(let i in this.$outContainer){
            if(this.$outContainer[i].nodeType==1){
                this.$outContainer[i].classList.remove("is-disable")
            }
        }

        TweenMax.to(this.$outContainer,1.4,{
            delay: 2.0,
            css:{
                'pointer-events': 'all',
                'opacity' : 1,
            },
            ease: Power2.easeOut
        })

    }
}